import React from 'react'
import Container from 'react-bootstrap/esm/Container'
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { MdDeleteForever } from "react-icons/md";

export default function BookList({appointment,setAppointment}) {
  const handleDelete =(id)=>{
    setAppointment(appointment.filter((item)=>item.id !==id))
}

const handleDoubleClick =(id)=>{
    setAppointment(
        appointment.map((item) =>
          item.id === id ? { ...item, booked: !item.booked } : item
        )
    )
}
console.log(appointment);
  return (
    <Container>
      <h3 className="display-6 mb-2">Booked List</h3>
      
    {!appointment.length &&(<img src="./img/booked.jpg" alt="" width="70%"/>)}
     {appointment.map((item)=>{
    const{id, name, day, booked, tel, tourname }=item 
    return(
     
       <div key={id} className={booked ? "appointment booked":"appointment "}
      onDoubleClick={()=>handleDoubleClick(id)}>
          <Row>
              <Col>
               <h4>{name}</h4>
              <h5>{tourname}</h5>
              <h5>{tel}</h5>

              </Col>
               <Col>
              {/* <h6>{day.toDateString()}</h6>  */}
              <h6>{new Date(day).toLocaleDateString()}</h6>
              <h6>{new Date(day).toLocaleTimeString()}</h6>
             </Col> 
             <Col className=" d-flex justify-content-end align-items-center">
             <MdDeleteForever 
               className="text-danger fs-3 " 
        type="button" 
              onClick={()=>handleDelete(id)}/>
              </Col>
           </Row>
      </div> 
  )
})} 
    </Container>
  )
}
